import React from 'react'
import '../Css/Course.css';
import ClientBanner from './ClientBanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';


function FindHelper() {
  const clientLogin = () => {
      const url = "https://homerepairexperthk.com/clientSide";
      window.open(url,'_blank');
  }

  return (
    <div>
      <Helmet>
        <title>全港家居維修師傅配對 | 覆蓋九龍、港島、新界各區 | 維修王</title>
        <meta name="description" content="維修王提供全港 18 區家居維修配對服務，無論在觀塘、元朗、荃灣或將軍澳，只需 1 分鐘即可配對專業水電、冷氣及裝修師傅。" />
        <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "維修王 Home Repair Expert App",
        "operatingSystem": "iOS, Android",
        "applicationCategory": "LifestyleApplication", // 生活類應用
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8", // 建議填寫 App Store 真實評分
          "ratingCount": "150"  // 建議填寫真實評價人數
        },
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "HKD"
        },
        "downloadUrl": "https://play.google.com/store/apps/details?id=com.homerepairexperthk.app", // 或直接放 App Store 連結
        "featureList": "快速配對師傅, 透明報價系統, 師傅評分查看, 24小時維修發單"
      })}
    </script>
        
        
        
        
        {/* Social Media Tags (Open Graph) - 讓 WhatsApp/FB 預覽更有吸引力 */}
        <meta property="og:title" content="免費下載維修王 App | 一鍵配對全港專業師傅" />
        <meta property="og:description" content="不再怕維修被「開天索價」！公開透明的報價與師傅評價系統，讓你找維修更安心。立即點擊查看教學並下載。" />
        <meta property="og:image" content="https://homerepairexperthk.com" />
        <meta property="og:url" content="https://homerepairexperthk.com" />
      </Helmet>
      
      <div className="Course-Wrapper">
      <div className="Course-Content">
        <div className="Course-Body">
          <div className="Course-Header-Image">
            <img src={require('../Image/FindHelp.png')} style={{width:'1000px',height:'300px'}} alt="家居水電維修"/>
          </div>
          
          <ClientBanner />    
          
          <div className="Course-Body-Context">
              <div className="Course-Body-Header">[輕鬆解決家居煩惱！一鍵預約專業師傅｜您的居家修維修好幫手] </div>  
              <div className="Course-Body-Wrapper">
                <div className="Course-Body-Content" id="Course-Body-Content-Left">
                <p>
                  漏水？停電？門鎖問題？ 生活突發狀況讓人頭痛又慌張！別再四處尋找、比價耗時費力了！
                </p>
                <p>
                  立即下載【維修王】家居維修平台App
                </p>    
                <ul>
                  <li>
                    👉 24小時快速預約：水電維修、冷氣清洗、木工泥作、家電安裝，專業師傅即刻支援！
                  </li>
                  <li>
                    👉 價格透明安心：報價清晰、無隱藏費用，杜絕亂收費！
                  </li>
                  <li>
                    👉 大量認證好師傅：用戶真實評價、技術評分，幫您精準匹配在地優質師傅！
                  </li>
                  <li>
                    👉 全程平台保障：從預約到完工，平台擔保交易安全與服務品質！
                  </li>
                </ul>
                </div>    
                <div className="Course-Body-Image" id="Course-Body-Content-Right">
                    <img src={require('../Image/HomeScreen1.png')} style={{ width: '200px', height: '400px' }} alt="家居水電維修" />
                </div>
              </div>
          </div>       

          <div className="Course-Body-Context">
              <div className="Course-Body-Header">[免滋擾式平台-選項] </div>  
              <div className="Course-Body-Wrapper">
                <div className="Course-Body-Content" id="Course-Body-Content-Left">
                  <p>有見近年推銷電話數量大增,加上當中含有詐騙成份.個人電話號碼私隱性更為重要,尤其對長者朋友.現時市面的維修平台,
                     是把服務申請者的電話號碼,個人資料公開發放.一經申請服務,每每在盒時間收到十多個服價電話回覆.對服務申請者帶來極大困擾.
                  </p>
                  <p>
                    有見及此,我們自發的家居維修平台,是免滋擾式.只有客戶的居住區或,家居維修種類會被發佈至已通過我們註冊的維修師傅.
                    服務申請者的個人資料完全得到保障.因此用戶可安心享用.
                  </p>    
                </div>    
                <div className="Course-Body-Image" id="Course-Body-Content-Right">
                    <img src={require('../Image/HomeScreen2.png')} style={{ width: '200px', height: '400px' }} alt="家居水電維修" />
                </div>
              </div> 
          </div>       
          <div className="Course-Body-Context">
            <div className="Course-Body-Header">[關愛家庭-選項]</div>  
              <div className="Course-Body-Wrapper">
                <div className="Course-Body-Content" id="Course-Body-Content-Left">
                  <p>我們提供關愛家庭選項,維修師傅會以低於市場維修價提供家居維修服務.關愛家庭包括:低收入家庭,長者,傷殘人士.希望透過我們的平台,能改善家居環境.
                  </p>
                </div>  
                <div className="Course-Body-Image" id="Course-Body-Content-Right">
                    <img src={require('../Image/HomeScreen3.png')} style={{ width: '200px', height: '400px' }} alt="家居水電維修" />
                </div>
              </div>  
          </div>
          

          <div className="Course-Body-Context">
            <div className="FindHelperLogo">
              <div className="Course-Body-Header">[告別居家修繕的焦慮與麻煩！無論是緊急搶修、定期保養，還是居家改造，【維修王】一站式滿足您的所有需求！]</div>
            </div>  
          </div>  

          <section className="service-locations" style={{ padding: '40px 20px', background: '#f9f9f9' }}>
            <h2 style={{ textAlign: 'center' }}>維修王服務地區</h2>
            <p style={{ textAlign: 'center', color: '#666' }}>我們的專業師傅團隊遍佈全港，隨時為你提供即時家居維修服務：</p>
              <div className="location-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginTop: '30px' }}>
                <div>
                  <h3>九龍區家居維修</h3>
                  <p>觀塘、九龍灣、旺角、尖沙咀、深水埗、紅磡、黃大仙、將軍澳</p>
                  </div>
                <div>
                  <h3>新界區家居維修</h3>
                    <p>荃灣、元朗、屯門、大埔、沙田、粉嶺、上水、天水圍</p>
                </div>
                <div>
                  <h3>港島區家居維修</h3>
                  <p>中環、銅鑼灣、鰂魚涌、柴灣、西環、鴨脷洲、赤柱</p>
                </div>
              </div>
          </section>

          <ClientBanner/>
      </div>
      </div>
      </div>  
    </div>
    
    
  )
}

export default FindHelper
